import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader, StatusChip } from "./primitives";

const Staking = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-24 lg:py-32 border-t border-line" data-testid="staking-section">
      <div className="section-shell grid gap-12 lg:grid-cols-2 lg:gap-20 items-start">
        <div>
          <SectionHeader
            index={7}
            eyebrow="Staking"
            title={<>Hold. Stake.<br />Participate.</>}
            sub={config.staking.note}
            testId="staking-header"
          />
          <Reveal delay={0.15} className="mt-8">
            <StatusChip tone="gold" testId="staking-status-chip">Staking — {config.staking.status}</StatusChip>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="card-surface rounded-xl overflow-hidden" data-testid="staking-table">
            <div className="grid grid-cols-2 border-b border-line bg-navy/50 px-6 sm:px-8 py-4">
              <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-slate">Lock Period</span>
              <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-slate text-right">Reward Multiplier</span>
            </div>
            {config.staking.tiers.map((t, i) => (
              <div
                key={t.lock}
                className={`grid grid-cols-2 px-6 sm:px-8 py-5 ${i !== config.staking.tiers.length - 1 ? "border-b border-line" : ""} hover:bg-teal/5 transition-colors duration-300`}
                data-testid={`staking-tier-${i}`}
              >
                <span className="font-mono text-sm sm:text-base text-mist">{t.lock}</span>
                <span className="font-mono text-sm sm:text-base font-semibold text-teal text-right">{t.multiplier}</span>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-slate leading-relaxed" data-testid="staking-disclaimer">
            Multipliers are protocol parameters, not return promises. No APY or APR is advertised unless officially provided.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Staking;
